"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSessionByWeb = exports.updateSession = exports.getSession = exports.getSessionInfo = void 0;

require("core-js/modules/es6.promise");

var _tool = require("./tool");

var _xhr = _interopRequireDefault(require("./xhr"));

var _config = require("../config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 客户端如果未登录返回结果为-1
var sessionInfo = {
  sid: -1,
  st: -1
}; // 储存session

var saveSession = function saveSession(sid, st) {
  sessionInfo.sid = sid || -1;
  sessionInfo.st = st || -1;
}; // 返回当前缓存session


var getSessionInfo = function getSessionInfo() {
  return sessionInfo;
}; // 从native获取session 因回调success也可能出现-1所以统一resolve


exports.getSessionInfo = getSessionInfo;

var getSession = function getSession() {
  return new Promise(function (resolve) {
    var WLSession = window.WLSDK.WLSession;

    if (WLSession) {
      WLSession.getSessionInfo({}, {
        closeTips: true
      }).then(function (_ref) {
        var sid = _ref.sid,
            st = _ref.st;
        saveSession(sid, st);
        return resolve(sessionInfo);
      }).catch(function () {
        saveSession(-1, -1);
        resolve(sessionInfo);
      });
    } else {
      resolve(sessionInfo);
    }
  });
}; // 从native更新session(此方法目前只在goblin中调用,触发条件为访问业务接口下线)


exports.getSession = getSession;

var updateSession = function updateSession() {
  var errorCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return new Promise(function (resolve) {
    var WLSession = window.WLSDK.WLSession;
    (0, _tool.isLogin)().then(function () {
      WLSession.updateSession({
        errorCode: errorCode,
        sessionInfo: sessionInfo
      }).then(function (_ref2) {
        var sid = _ref2.sid,
            st = _ref2.st;
        saveSession(sid, st);
        return resolve(sessionInfo);
      }).catch(function () {
        resolve(sessionInfo);
      });
    }).catch(function () {
      console.log('need login');
      resolve(sessionInfo);
    });
  });
}; // dev中网页login。


exports.updateSession = updateSession;

var getSessionByWeb = function getSessionByWeb() {
  return new Promise(function (resolve) {
    var mobile = localStorage.getItem('sso_mobile');
    var type = localStorage.getItem('sso_type') || 'driver';
    var st = localStorage.getItem('sso_st') || -1;
    var sid = localStorage.getItem('sso_sid') || -1;
    var code = _config.SESSION.code,
        codeType = _config.SESSION.codeType,
        isPwdEncrypt = _config.SESSION.isPwdEncrypt;
    var params = {
      mobile: mobile,
      code: code,
      codeType: codeType,
      isPwdEncrypt: isPwdEncrypt,
      domainId: _config.SESSION[type].domainId,
      appClientId: _config.SESSION[type].appClientId
    };

    if (st !== -1 && sid !== -1) {
      saveSession(sid, st);
      resolve(sessionInfo);
    } else if (!mobile) {
      console.log('sso_mobile not found');
      resolve(sessionInfo);
    } else {
      (0, _xhr.default)(_config.SESSION.url, params).then(function (resp) {
        var _resp$content = resp.content,
            id = _resp$content.id,
            token = _resp$content.token;
        saveSession(id, token);
        resolve(sessionInfo);
      });
    }
  });
};

exports.getSessionByWeb = getSessionByWeb;